import styled from 'styled-components'

import Link from '../Link'
import Icon from '../Icon'

export const DownloadFilesContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.brownBack};
  border-left: 7px solid ${({ theme }) => theme.colors.greyFields};
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
  padding: 2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
`

export const Title = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBaseBold};
  ${({ theme }) => theme.colors.blueSecondaryBis};
`
export const DownloadFilesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  li:not(:last-child) {
    border-right: 1px dashed ${({ theme }) => theme.colors.greyFields};
    padding-right: 2.4rem;
  }
  li:not(:first-child) {
    padding-left: 2.4rem;
  }
`
// export const DownloadFilesListItem = styled.li`
//
// `

export const DownloadLink = styled(Link)`
  align-items: baseline;
  ${({ theme }) => theme.textStyles.montserratTextBase};
  ${({ theme }) => theme.colors.blueSecondaryBis};
`

export const DownloadIcon = styled(Icon)`
  margin-left: 1.1rem;
`
